import * as React from 'react';
type Props = {
  className?: string;
};
export function Chain({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-chain"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1537 10.811C15.3654 12.0227 15.4955 13.9209 14.4183 15.1351L14.2983 15.2625L10.2164 19.3445C9.05277 20.5081 7.15618 20.4598 5.8972 19.3255L5.76481 19.1998L3.99704 17.4321C2.78536 16.2204 2.65517 14.3221 3.73237 13.1079L3.85241 12.9805L5.15416 11.6788C5.54469 11.2882 6.17785 11.2882 6.56838 11.6788C6.93101 12.0414 6.95691 12.6132 6.64608 13.0058L6.56838 13.093L5.26662 14.3947C4.90034 14.761 4.90613 15.4198 5.317 15.9145L5.41126 16.0179L7.17903 17.7856C7.64793 18.2545 8.31361 18.316 8.71936 18.003L8.80216 17.9303L12.8841 13.8483C13.2504 13.482 13.2446 12.8232 12.8337 12.3285L12.7395 12.2252L11.6788 11.1645C11.2883 10.774 11.2883 10.1408 11.6788 9.75032C12.0414 9.38769 12.6133 9.36179 13.0058 9.67262L13.093 9.75032L14.1537 10.811ZM19.1998 5.76481C20.4115 6.9765 20.5417 8.87475 19.4645 10.089L19.3445 10.2164L17.8981 11.6627C17.5076 12.0532 16.8744 12.0532 16.4839 11.6627C16.1213 11.3001 16.0954 10.7283 16.4062 10.3357L16.4839 10.2485L17.9303 8.80216C18.2965 8.43588 18.2908 7.77704 17.8799 7.28235L17.7856 7.17903L16.0179 5.41126C15.549 4.94235 14.8833 4.88088 14.4775 5.19384L14.3947 5.26662L10.3128 9.34856C9.87162 9.78973 9.7969 10.6649 10.1424 11.1257L10.2171 11.212L11.2777 12.2727C11.6683 12.6632 11.6683 13.2964 11.2777 13.6869C10.9151 14.0496 10.3433 14.0755 9.95074 13.7646L9.86352 13.6869L8.80286 12.6263C7.59903 11.4224 7.67296 9.30543 8.77642 8.06393L8.89858 7.93434L12.9805 3.85241C14.1441 2.68881 16.0407 2.73709 17.2997 3.87137L17.4321 3.99705L19.1998 5.76481Z"
        fill="currentColor"
      />
    </svg>
  );
}
